//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "integralshop",
  data(){
      return {
        list:[]
      }
  },
  methods:{
      getList(){
        this.axios.post('/xcx/Order/codeList').then(res=>{
          this.list=res.data.data;
        })
      }
  },
  created() {
      this.getList();
  }
}



// WEBPACK FOOTER //
// ./src/components/integralshop/integralshop.vue